import Table from "#components/table/table";
import { formatDateOnly } from "#utils";

function AnimalTable({ animals }) {
  return (
    <div className="mt-8 flow-root">
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <Table
            headers={headers}
            items={formatAnimalsIntoTableItems(animals)}
          />
        </div>
      </div>
    </div>
  );
}
const formatAnimalsIntoTableItems = (animals) => {
  const items = animals?.map((animal) => ({
    key: animal.animalId,
    columns: [
      linkColumnByValue(animal.all4CatsId, `/animal/${animal.animalId}`),
      columnByValue(animal.name),
      columnByValue(formatDateOnly(animal.birthDate)),
      columnByValue(formatDateOnly(animal.intakeDate)),
      columnByValue(animal.status),
      columnByValue(animal.isFixed),
      columnByValue(animal.color),
      columnByValue(animal.coat),
      columnByValue(animal.notes),
    ],
  }));
  return items;
};

const baseColumnClassName =
  "px-3 py-4 text-sm text-gray-500 lg:table-cell dark:text-gray-400 whitespace-nowrap";

const linkColumnClassName =
  "px-3 py-4 text-sm text-blue-500 hover:font-semibold lg:table-cell dark:text-gray-400 whitespace-nowrap";

const linkColumnByValue = (value, href) => ({
  className: linkColumnClassName,
  content: value,
  href,
});

const columnByValue = (value) => ({
  className: baseColumnClassName,
  content: value,
});
const baseHeaderClassName =
  "py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white whitespace-nowrap";
const headerByName = (name) => ({
  className: baseHeaderClassName,
  content: name,
});

const headers = [
  headerByName("All4Cats ID"),
  headerByName("Name"),
  headerByName("Birthday"),
  headerByName("Intake Date"),
  headerByName("Status"),
  headerByName("Is Fixed"),
  headerByName("Color"),
  headerByName("Coat"),
  headerByName("Notes"),
];
export default AnimalTable;
